import { Layout } from '@/components/Layout'
import { Splash } from '@/components/Splash/Splash'
import { useWalletAuth } from '@/hooks/useWalletAuth'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

export default function Home() {
  const { ready, hasConnectedWallet } = useWalletAuth()
  const router = useRouter()

  useEffect(() => {
    if (ready && hasConnectedWallet) router.push('/claim')
  }, [ready, hasConnectedWallet, router])

  return <Layout title="$ZORA Claim">{!hasConnectedWallet && <Splash />}</Layout>
}
